import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-next-due-maintenance-delete-dialog",
    templateUrl: "./next-due-maintenance-delete-dialog.component.html",
    styleUrl: "./next-due-maintenance-delete-dialog.component.scss",
    standalone: false,
})
export class NextDueMaintenanceDeleteDialogComponent {
    constructor(private dialogRef: MatDialogRef<NextDueMaintenanceDeleteDialogComponent>) {}

    onCancel() {
        this.dialogRef.close(false);
    }

    onConfirm() {
        this.dialogRef.close(true);
    }
}
